import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { ActivatedRoute } from '@angular/router';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateFeeStructureComponent } from "../../components/fee-structure/create-fee-structure/create-fee-structure.component";
import { DeleteFeeStructureComponent } from "../../components/fee-structure/delete-fee-structure/delete-fee-structure.component";

@Component({
  selector: 'app-fee-breakdown',
  imports: [ToolBarComponent, SharedModule, CreateFeeStructureComponent, DeleteFeeStructureComponent],
  templateUrl: './fee-breakdown.component.html',
  styleUrl: './fee-breakdown.component.scss'
})
export class FeeBreakdownComponent {

  feeGroupId: string = '';
  isEditStructure: boolean = false;
  isAddFeeStructure: boolean = false;
  feeList: any[] = [];
  responseData: any;
  selectedRowData: any;
  loading: boolean = false;
  deleteFeeStructure: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private api: FeeService,
    private localStorage: LocalStorageService
  ) {
    this.route.params.subscribe(params => {
      this.feeGroupId = params['id'];
      console.log("Fee Group ID:", this.feeGroupId);
      // You can use the feeGroupId to fetch and display the breakdown details
    });
  }


    feeActionItem: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Fee Structure',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditStructure = true;
          }
        },
        {
          label: 'Delete Fee Structure',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.deleteFeeStructure = true;
          }
        }
      ]
    }
  ]

  

  ngOnInit() {
    this.getFeeBreakdownDetails();
  }

  getFeeBreakdownDetails() {

    const params = {
      organization_id: this.localStorage.getOrganizationId(),
      group_id: this.feeGroupId
    };

    this.loading = true;

    this.api.getAllFeeStructures(params).subscribe(
      {
        next: (response: any) => {
          this.loading = false;
          this.feeList = JSON.parse(response.result);
          this.responseData = JSON.parse(response.response);
          // Handle the response and display the breakdown details
        },
        error: (error: any) => {
          this.loading = false;
          this.feeList = [];
          this.responseData = {};
          // Handle error
          console.error("Error fetching fee breakdown details:", error);
        }
      }
    );
  }

  handleFeeBreakdown() {
    this.isAddFeeStructure = true;
  }


  reloadData() {
    this.getFeeBreakdownDetails();
  }

  getTotalAmount(): number {
    return this.feeList.reduce((acc, curr) => acc + Number(curr.amount || 0), 0);
  }

  setRowData(rowData: any) {
    this.selectedRowData = rowData;
  }

}
